import { AbstractControl, ValidationErrors } from '@angular/forms';

/** Calculate age in full years from a Date or ISO date string */
export function calculateAge(dob: string | Date): number {
  if (!dob) return 0;
  const birthDate = typeof dob === 'string' ? new Date(dob) : dob;
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) age--;
  return age;
}

/** Validator enforcing a minimum age in years */
export function minAgeValidator(minAge: number) {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null;
    const age = calculateAge(value);
    return age >= minAge ? null : { minAge: true };
  };
}

/** Strip leading '@' from a social username */
export function cleanSocialHandle(handle: string | null | undefined): string {
  if (!handle) return '';
  return handle.replace(/^@/, '').trim();
}

/** Build platform URL from username; returns empty string if missing */
export function buildSocialUrl(platform: 'twitter' | 'instagram', username: string): string {
  if (!username) return '';
  if (platform === 'twitter') return `https://x.com/${username}`;
  return `https://www.instagram.com/${username}`;
}